import React from 'react';
import { HindiDiwas2026 } from '../views';

const SchoolProgrampage = () => {
  return <HindiDiwas2026 />;
};

export default SchoolProgrampage;